function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import _ from "lodash";
export const transformReducedPropertiesToStyle = (reducedProperties)=>{
    // required for properties that effect multiple css properties
    // sort by elements that have ";" first (so the more specific properties are applied last)
    const entries = _.sortBy(Object.entries(reducedProperties || {}), ([key, value])=>{
        return key.includes(";") ? 0 : 1;
    });
    let output = entries.reduce((acc, [key, value])=>{
        return _object_spread({}, acc, transformPropertyLiteraForDom(key, value));
    }, {});
    // required for css properties that have multiple values like transition, transform, etc
    output = combineArrayElements(output);
    // top
    if (output["borderTopWidth"]) {
        output = _object_spread({
            borderTopStyle: "solid"
        }, output);
    }
    // right
    if (output["borderRightWidth"]) {
        output = _object_spread({
            borderRightStyle: "solid"
        }, output);
    }
    // bottom
    if (output["borderBottomWidth"]) {
        output = _object_spread({
            borderBottomStyle: "solid"
        }, output);
    }
    // left
    if (output["borderLeftWidth"]) {
        output = _object_spread({
            borderLeftStyle: "solid"
        }, output);
    }
    // see if there are custom css properties
    const customCSSProperty = reducedProperties === null || reducedProperties === void 0 ? void 0 : reducedProperties["prop:custom-css"];
    if (customCSSProperty) {
        if (customCSSProperty.type === "property-custom-css") {
            const values = customCSSProperty.properties;
            for (const propertyValue of values){
                if (propertyValue.value.trim() && propertyValue.property.trim()) {
                    const cssPropertyName = propertyValue.property;
                    const cssValue = propertyValue.value;
                    output[cssPropertyName] = cssValue;
                }
            }
        }
    }
    return output;
};
// converts css length to string
const cssLengthToString = (length)=>{
    if (length.unit !== "none" && length.unit !== "raw") {
        return `${length.value || 0}${length.unit}`;
    }
    return length.value;
};
// converts css number unit to string
const cssNumberUnitToString = (numberUnit)=>{
    return `${numberUnit.value}${numberUnit.unit}`;
};
export const transformPropertyLiteraForDom = (propertyKey, propertyValue)=>{
    // It's not a css property
    if (!propertyKey.startsWith("css:")) {
        return {};
    }
    const cssPropertyName = propertyKey.replace("css:", "");
    const cssPropertyNames = cssPropertyName.split(";").map((e)=>isArrayElement(e) ? e : _.camelCase(e));
    const reduce = (cssPropertyName)=>{
        var _propertyValue_value;
        if (propertyValue.type === "css-font") {
            const defaults = `system, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`;
            return _object_spread({
                fontFamily: propertyValue.kind === "system" || propertyValue.value == "System Font" ? defaults : `'${propertyValue.value}', ${defaults}`
            }, propertyValue.weight ? {
                fontWeight: propertyValue.weight
            } : {}, propertyValue.style ? {
                fontStyle: propertyValue.style
            } : {});
        }
        if (propertyValue.type === "css-length") {
            if (propertyValue.unit !== "none" && propertyValue.unit !== "raw") {
                return {
                    [cssPropertyName]: `${propertyValue.value || 0}${propertyValue.unit}`
                };
            }
            return {
                [cssPropertyName]: propertyValue.value
            };
        }
        if (propertyValue.type === "css-percentage") {
            if (propertyValue.unit !== "none") {
                return {
                    [cssPropertyName]: `${propertyValue.value}${propertyValue.unit}`
                };
            }
            return {
                [cssPropertyName]: propertyValue.value
            };
        }
        if (propertyValue.type === "css-filter" || propertyValue.type === "css-backdrop-filter") {
            const filters = propertyValue.filters;
            if (filters && filters.length > 0) {
                const filterValues = filters.map((filter)=>{
                    const name = filter.type;
                    const length = cssLengthToString(filter.value);
                    return `${name}(${length})`;
                }).join(" ");
                return _object_spread({
                    [cssPropertyName]: filterValues
                }, propertyValue.type === "css-backdrop-filter" ? {
                    WebkitBackdropFilter: filterValues
                } : {
                    WebkitFilter: filterValues
                });
            }
        }
        if (propertyValue.type === "css-box-shadow") {
            const shadow = propertyValue;
            const isBoxShadow = cssPropertyName === "boxShadow";
            return {
                [cssPropertyName]: `${cssNumberUnitToString(shadow.xOffset)} ${cssNumberUnitToString(shadow.yOffset)} ${cssNumberUnitToString(shadow.blurRadius)} ${isBoxShadow ? cssNumberUnitToString(shadow.spreadRadius) : ""} ${shadow.color.value}${shadow.inset && isBoxShadow ? " inset" : ""}`
            };
        }
        if (propertyValue.type === "css-background-image") {
            const fn = propertyValue.functions[0];
            if (fn) {
                if (fn.type === "linearGradient") {
                    const linearGradient = fn;
                    const angle = cssNumberUnitToString(linearGradient.angle);
                    const sorted = _.sortBy(linearGradient.stops, (c)=>parseFloat(c.position.value));
                    const stops = sorted.map((stop)=>`${stop.color.value} ${cssNumberUnitToString(stop.position)}`).join(", ");
                    return {
                        background: `linear-gradient(${angle}, ${stops})`
                    };
                }
                if (fn.type === "radialGradient") {
                    const radialGradient = fn;
                    const shape = radialGradient.shape;
                    const sorted = _.sortBy(radialGradient.stops, (c)=>parseFloat(c.position.value));
                    const stops = sorted.map((stop)=>`${stop.color.value} ${cssNumberUnitToString(stop.position)}`).join(", ");
                    return {
                        background: `radial-gradient(${shape}, ${stops})`
                    };
                }
                if (fn.type === "image") {
                    const image = fn;
                    return {
                        background: `url(${image.url}) ${image.verticalPosition} ${image.horizontalPosition} / ${image.size} no-repeat`
                    };
                }
            }
        }
        if (propertyValue.type === "css-transition") {
            const transitions = propertyValue;
            return {
                transitionProperty: transitions.property,
                transitionDuration: cssNumberUnitToString(transitions.duration),
                transitionTimingFunction: transitions.timingFunction,
                transitionDelay: cssNumberUnitToString(transitions.delay)
            };
        }
        if (propertyValue.type === "css-transform-rotate") {
            return {
                [cssPropertyName]: `rotate(${propertyValue.value.value}${propertyValue.value.unit})`.trim()
            };
        }
        if (propertyValue.type === "css-transform-scale") {
            return {
                [cssPropertyName]: `scale(${propertyValue.value.value})`.trim()
            };
        }
        if (propertyValue.type === "css-transform-translate") {
            const x = propertyValue.x ? cssLengthToString(propertyValue.x) : "0px";
            const y = propertyValue.y ? cssLengthToString(propertyValue.y) : "0px";
            return {
                [cssPropertyName]: `translate(${x},${y})`.trim()
            };
        }
        if (!("value" in propertyValue) || propertyValue.value === undefined) {
            return {};
        }
        // Right now transform everything to a string
        const propertyValueString = (_propertyValue_value = propertyValue.value) === null || _propertyValue_value === void 0 ? void 0 : _propertyValue_value.toString();
        return {
            [cssPropertyName]: propertyValueString
        };
    };
    const output = cssPropertyNames.reduce((acc, cssPropertyName)=>{
        return _object_spread({}, acc, reduce(cssPropertyName));
    }, {});
    return _object_spread({}, output);
};
// helpers
// includes text (or nothing) in brackets with regex.
// for example:
// transform[rotate] = true
// padding[] = true
// padding[bottom] = true
// padding = false (no brackets)
const isArrayElement = (value)=>{
    return /\[.*\]/.test(value);
};
// returns text in brackets or undefined
// for example:
// transform[rotate] = 'rotate'
// padding[] = ''
// padding[bottom] = 'bottom'
// padding = undefined (no brackets)
const extractTextFromBrackets = (value)=>{
    const match = value.match(/\[(.*)\]/);
    return match ? match[1] : undefined;
};
const extractTextBeforeBrackets = (value)=>{
    const match = value.match(/(.*)\[.*\]/);
    return match ? match[1] : value;
};
const combineArrayElements = (properties)=>{
    let cssArrayTypes = {};
    let otherElements = {};
    Object.entries(properties).forEach(([key, value])=>{
        if (isArrayElement(key)) {
            const text = extractTextFromBrackets(key);
            const beforeText = extractTextBeforeBrackets(key);
            if (text && value) {
                cssArrayTypes[beforeText] = `${cssArrayTypes[beforeText] || ""} ${value}`.trim();
            }
        } else {
            otherElements[key] = value;
        }
    });
    return _object_spread({}, otherElements, cssArrayTypes);
};
